import { ReactElement, useContext, useMemo } from "react";

import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions, useIsMobile } from "@ryde/shared";

import { CheckboxMui, CheckboxStar } from "../../../controls";
import { TableWrapperContext } from "../table/table-wrapper.context";

interface IMultiIconHeaderContent {
  onCheckboxClick: () => void;
  onStarClick: () => void;
  isStarredChecked: boolean;
  isCheckboxChecked: boolean;
}

export const MultiIconHeaderContent = ({
  onCheckboxClick,
  onStarClick,
  isStarredChecked,
  isCheckboxChecked,
}: IMultiIconHeaderContent): ReactElement => {
  const { isMobile } = useIsMobile();
  const { entity } = usePageContext();
  const { isGridSingleSelectView } = useContext(TableWrapperContext);
  const hideCheckbox = useMemo(() => {
    return (
      isEntityWithoutBulkActions(entity) ||
      (entity === "ride" && isGridSingleSelectView)
    );
  }, [entity, isGridSingleSelectView]);
  return (
    <div className="multi_icon_cell">
      {!hideCheckbox && (
        <CheckboxMui
          checked={isCheckboxChecked}
          onCheckboxToggle={onCheckboxClick}
        />
      )}
      {!isMobile && (
        <CheckboxStar
          checked={isStarredChecked}
          onCheckboxToggle={onStarClick}
        />
      )}
    </div>
  );
};
